import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { Raffle } from './raffle'
import { RaffleSerializer } from './raffle.serializer'

@Injectable()
export class RaffleService extends ResourceService<Raffle> {
  constructor(http: HttpClient, raffleSerializer: RaffleSerializer) {
    super(http, `${environment.backendApiUrl}/raffles`, raffleSerializer)
  }
}
